import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { RiseOutlined } from '@ant-design/icons';
import { useAddTripAdditionalCost } from 'api/additional-cost/use-add-trip-additional-cost';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { AdditionalCostModal } from 'components/common/additional-cost-modal';
import type { IAdditionalCostFormFields } from 'components/common/additional-cost-modal/types';
import { tripAdditionalCostTypes } from './constants';
import type { ITripAddAdditionalCostProps } from './types';

const TripAddAdditionalCostComponent: React.FC<ITripAddAdditionalCostProps> = (props) => {
  const { tripId } = props;
  const { t } = useTranslation('additional-cost');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { mutateAsync: addTripAdditionalCost, isLoading } = useAddTripAdditionalCost();

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  const onFinish = async (values: IAdditionalCostFormFields) => {
    await addTripAdditionalCost({ ...values, tripId });
  };

  return (
    <>
      <Button icon={<RiseOutlined />} onClick={handleOpen}>
        {t('add_additional_cost')}
      </Button>
      <AdditionalCostModal
        isLoading={isLoading}
        isOpen={isModalOpen}
        availableTypes={tripAdditionalCostTypes}
        onClose={handleClose}
        onFinish={onFinish}
      />
    </>
  );
};

export const TripAddAdditionalCost = withRoleGuard<ITripAddAdditionalCostProps>(TripAddAdditionalCostComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.transport_manager,
  UserRole.customer_manager,
  UserRole.storekeeper,
]);
